/**
 * Orario di oggi del punto vendita (snippets/store-hours-today.liquid): solo nei giorni di apertura.
 * data-hours: { "0": "Chiuso", "1": "16:00-19:00", "2": "10:00-13:00, 15:00-19:00", ... } (0 = domenica).
 * data-special: { "2026-10-10": "10:00-13:00, 15:00-19:00", ... } aperture straordinarie, hanno la precedenza.
 * Il giorno è quello di Roma, indipendente dal fuso del visitatore.
 */
class StoreHoursToday extends HTMLElement {
  connectedCallback() {
    let hours;
    try {
      hours = JSON.parse(this.dataset.hours || '{}');
    } catch {
      return;
    }

    let special = {};
    try {
      special = JSON.parse(this.dataset.special || '{}');
    } catch {
      special = {};
    }

    const now = new Date();
    const isoDate = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Rome' }).format(now); // AAAA-MM-GG
    const weekday = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Rome', weekday: 'short' }).format(now);
    const index = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(weekday);

    const specialToday = String(special[isoDate] ?? '').trim();
    const today = specialToday || String(hours[index] ?? '').trim();
    if (!today) return;

    // Nei giorni di chiusura resta il testo neutro ("Orari di apertura"): niente "chiuso" su un negozio online.
    if (/^chiuso$/i.test(today)) return;

    const formatted = today.replace(/\s*-\s*/g, '–').replace(/\s*,\s*/g, ' · ');
    this.textContent = specialToday
      ? `Aperti straordinariamente oggi ${formatted}`
      : `Negozio aperto oggi ${formatted}`;
    this.classList.add('is-open');
  }
}

if (!customElements.get('store-hours-today')) {
  customElements.define('store-hours-today', StoreHoursToday);
}
